/**
 * @generated SignedSource<<fc985688d4edc54ede1c456798932386>>
 * @relayHash e00cc09a175a06b869ceb070fb65279c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e00cc09a175a06b869ceb070fb65279c

import { ConcreteRequest } from 'relay-runtime';
export type PregnancyStatus = "NOT_PREGNANT" | "PREGNANT" | "UNKNOWN";
export type Ch_updatePatientGynaecologyInput = {
  firstPeriodAtYear?: number | null;
  menopauseSinceYear?: number | null;
  patientId: string;
  pregnancyHistory?: string | null;
  pregnancyStatus: PregnancyStatus;
  weeksOfPregnancy?: number | null;
};
export type chUpdateAllPatientGynaecologyMutation$variables = {
  input: Ch_updatePatientGynaecologyInput;
};
export type chUpdateAllPatientGynaecologyMutation$data = {
  readonly updateAllPatientGynaecology: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly gynaecology: {
      readonly firstPeriod: number | null;
      readonly id: string;
      readonly menopauseSince: number | null;
      readonly patientId: string;
      readonly pregnancy: PregnancyStatus;
      readonly pregnancyHistory: string | null;
      readonly weeksOfPregnancy: number | null;
    } | null;
  };
};
export type chUpdateAllPatientGynaecologyMutation = {
  response: chUpdateAllPatientGynaecologyMutation$data;
  variables: chUpdateAllPatientGynaecologyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "Error",
  "abstractKey": "__isError"
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*:: as any*/),
  "type": "IneligibleForGynaecology",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Gynaecology",
  "kind": "LinkedField",
  "name": "gynaecology",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "menopauseSince",
      "storageKey": null
    },
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pregnancyHistory",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weeksOfPregnancy",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdateAllPatientGynaecologyMutation",
    "selections": [
      {
        "alias": "updateAllPatientGynaecology",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientGynaecologyPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientGynaecology",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdateAllPatientGynaecologyMutation",
    "selections": [
      {
        "alias": "updateAllPatientGynaecology",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientGynaecologyPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientGynaecology",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          (v8/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e00cc09a175a06b869ceb070fb65279c",
    "metadata": {},
    "name": "chUpdateAllPatientGynaecologyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "583f8cf92842903c09a293ff9f6e2ac8";

export default node;
